import { gql } from '@apollo/client';

import listingFields from '../fragments/listingFields';

const otherListingsQuery = gql`
  ${listingFields}
  query AssetListings(
    $graphId: String!
    $seller: String!
    $skip: Int
    $first: Int
  ) {
    listings(
      where: { status: CREATED, asset: $graphId, seller_not: $seller }
      #orderBy: starsPrice
      #orderDirection: asc
      skip: $skip
      first: $first
    ) {
      ...ListingField
    }
  }
`;

export default otherListingsQuery;
